import { useEffect } from 'react';
import { useMounted } from '@mantine/hooks';
import { useAuthStore } from '@/src/modules/auth/stores/use-auth-store';
import {
  mapContactsResponseToContactsModel,
  mapIndividualResponseToIndividualModel,
  mapUserResponseToUserModel,
} from '../../user/data/mappers';
import { useUserAddress } from '../../user/hooks/use-user-address';
import { useAddressStore } from '../stores/use-address-store';
import { useHasCompleteAuthToken } from './use-has-complete-auth-token';
import { useIsAuthenticated } from './use-is-authenticated';

export function useUserAddressSession() {
  const setUser = useAuthStore((state) => state.setUser);
  const setAuthStoreStatus = useAuthStore((state) => state.setStatus);
  const setAddress = useAddressStore((state) => state.setAddress);
  const setEmergencyContact = useAddressStore(
    (state) => state.setEmergencyContact
  );
  const hasCompleteAuthToken = useHasCompleteAuthToken();
  const isAuthenticated = useIsAuthenticated();
  const isMounted = useMounted();
  const { mutate: fetchUser } = useUserAddress();
  const setUserSession = async () => {
    setAuthStoreStatus('loading');
    const data = await fetchUser();
    if (!data) {
      return;
    }
    setUser(
      mapUserResponseToUserModel(data.user),
      mapIndividualResponseToIndividualModel(data.individual)
    );
    setAddress(data.address!);
    setEmergencyContact(
      mapContactsResponseToContactsModel(data.emergency_contact!)
    );
  };

  useEffect(() => {
    if (!isMounted || !hasCompleteAuthToken) {
      return;
    }

    if (!isAuthenticated) {
      setUserSession();
    }
  }, [isMounted]);
}
